import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledMapContainer: any = styled.div`
  width: 100%;
  height: 100%;
`;

export const StyledMapWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const StyledMapRefContainer: any = styled.div`
  border-radious: 8px;
  min-height: 78svh;

  @media (min-width: ${Breakpoints.b560}px) {
    min-height: 76svh;
  }      
`;


export const StyledDealerCardWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;
  pointer-events: none;
  
  & > * {
    pointer-events: auto;
  }

  @media (min-width: ${Breakpoints.b960}px) {
    padding: 16px;
  }
`;

export const StyledDealerCardOverlay = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
  z-index: 1000;
  
  @media (min-width: ${Breakpoints.b960}px) {
    bottom: 24px;
    left: 24px;
    right: 24px;
  }
  
  @media (min-width: ${Breakpoints.b1600}px) {
    bottom: 32px;
    left: 32px;
    right: 32px;
  }
`;

export const StyledDebugDealerList = styled.div`
  margin-top: 24px;
  padding: 16px;
  background: #f9f9f9;
  border: 2px dashed #ccc;
  border-radius: 8px;
  
  h3 {
    margin: 0 0 16px 0;
    color: #666;
  }
`;

export const StyledDebugDealerItem = styled.div<{ $isSelected: boolean }>`
  padding: 12px;
  margin-bottom: 8px;
  background: ${({ $isSelected }) => $isSelected ? '#e3f2fd' : 'white'};
  border: 2px solid ${({ $isSelected }) => $isSelected ? '#2196f3' : '#ddd'};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s;
  
  &:hover {
    border-color: #2196f3;
    background: #f5f5f5;
  }
  
  strong {
    display: block;
    margin-bottom: 4px;
    font-size: 16px;
  }
  
  p {
    margin: 4px 0;
    font-size: 14px;
    color: #666;
  }
  
  small {
    color: #999;
    font-size: 12px;
  }
  
  span {
    color: #2196f3;
    font-weight: bold;
  }
`;
